// @ts-nocheck
/* eslint-disable */

import moment from 'moment';
import {SaltusAny} from './SaltusAny';

// https://stackoverflow.com/questions/44134212/best-way-to-flatten-js-object-keys-and-values-to-a-single-depth-array
export function flattenObject(object: SaltusAny, keySeparator = '.') {
  const flattenRecursive = (
    obj: SaltusAny,
    parentProperty?: string,
    propertyMap: Record<string, unknown> = {}
  ) => {
    for (const [key, value] of Object.entries(obj)) {
      const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
      if (value && typeof value === 'object') {
        flattenRecursive(value, property, propertyMap);
      } else {
        propertyMap[property] = value;
      }
    }
    return propertyMap;
  };
  return flattenRecursive(object);
}

// function objectToDotNotation(obj, current) {
//   for (const key in obj) {
//     const value = obj[key];
//     const newKey = current ? `${current}.${key}` : key; // joined key with dot
//     if (value && typeof value === 'object') {
//       objectToDotNotation(value, newKey); // it's a nested object, so do it again
//     } else {
//       res[newKey] = value; // it's not an object, so set the property
//     }
//   }
// }
// Convert complex js object to dot notation js object
// url: https://github.com/vardars/dotize
// author: vardars

export const dotize = {
  valTypes: {
    none: 'NONE',
    primitive: 'PRIM',
    object: 'OBJECT',
    array: 'ARRAY',
    date: 'DATE',
  },

  getValType(val: SaltusAny) {
    if ((!val || typeof val != 'object') && !Array.isArray(val))
      return dotize.valTypes.primitive;
    if (Array.isArray(val)) return dotize.valTypes.array;
    if (typeof val == 'object') return dotize.valTypes.object;
  },

  getPathType(arrPath: string[]) {
    const arrPathTypes = [];
    for (const path in arrPath) {
      const pathVal = arrPath[path];
      if (!pathVal) arrPathTypes.push(dotize.valTypes.none);
      else if (dotize.isNumber(pathVal)) arrPathTypes.push(dotize.valTypes.array);
      else arrPathTypes.push(dotize.valTypes.object);
    }
    return arrPathTypes;
  },

  isUndefined(obj: string[]) {
    return typeof obj == 'undefined';
  },

  isNumber(f: string) {
    return !Number.isNaN(parseInt(f));
  },

  isDate(f: SaltusAny) {
    return f instanceof Date || moment.isMoment(f);
  },

  isEmptyObj(obj: SaltusAny) {
    for (const prop in obj) {
      if (Object.hasOwnProperty.call(obj, prop)) return false;
    }

    return JSON.stringify(obj) === JSON.stringify({});
  },

  isNotObject(obj: SaltusAny) {
    return !obj || typeof obj != 'object';
  },

  isEmptyArray(arr: string | any[]) {
    return Array.isArray(arr) && arr.length == 0;
  },

  isNotArray(arr: SaltusAny) {
    return Array.isArray(arr) == false;
  },

  removeEmptyArrayItem(arr: SaltusAny[]) {
    return arr.filter(function (el: string | null) {
      return el != null && el != '';
    });
  },

  getFieldName(
    field: string,
    prefix: SaltusAny,
    isRoot: boolean,
    isArrayItem: boolean | undefined,
    isArray: boolean | undefined
  ) {
    if (isArray)
      return (
        (prefix || '') +
        (dotize.isNumber(field) ? `[${field}]` : (isRoot && !prefix ? '' : '.') + field)
      );
    if (isArrayItem) return `${prefix || ''}[${field}]`;
    return (prefix ? `${prefix}.` : '') + field;
  },

  startsWith(val: string | any[], valToSearch: string) {
    return val.indexOf(valToSearch) == 0;
  },

  convert(obj: SaltusAny, prefix?: string | number) {
    let newObj = {};

    // primitives
    if (dotize.isNotObject(obj) && dotize.isNotArray(obj)) {
      if (prefix) {
        newObj[prefix] = obj;
        return newObj;
      }
      return obj;
    }

    return (function recurse(o, p, isRoot) {
      const isArrayItem = Array.isArray(o);
      for (const f in o) {
        const currentProp = o[f];
        if (currentProp && typeof currentProp === 'object') {
          if (Array.isArray(currentProp)) {
            if (dotize.isEmptyArray(currentProp)) {
              newObj[dotize.getFieldName(f, p, isRoot, false, true)] = currentProp;
            } else {
              newObj = recurse(
                currentProp,
                dotize.getFieldName(f, p, isRoot, false, true),
                isArrayItem
              ); // array
            }
          } else if (isArrayItem && dotize.isEmptyObj(currentProp) == false) {
            newObj = recurse(currentProp, dotize.getFieldName(f, p, isRoot, true)); // array item object
          } else if (dotize.isDate(currentProp)) {
            newObj[dotize.getFieldName(f, p, isRoot)] = currentProp.toString(); // primitive
          } else if (dotize.isEmptyObj(currentProp) == false) {
            newObj = recurse(currentProp, dotize.getFieldName(f, p, isRoot)); // object
          } else if (dotize.isEmptyObj(currentProp)) {
            newObj[dotize.getFieldName(f, p, isRoot, isArrayItem)] = currentProp;
          }
        } else if (isArrayItem || dotize.isNumber(f)) {
          newObj[dotize.getFieldName(f, p, isRoot, true)] = currentProp; // array item primitive
        } else {
          newObj[dotize.getFieldName(f, p, isRoot)] = currentProp; // primitive
        }
      }

      return newObj;
    })(obj, prefix, true);
  },

  backward(obj: {[x: string]: SaltusAny}, prefix: string | number) {
    let newObj = {};
    const arStartRegex = /\[(\d+)\]/g;

    // primitives
    if (dotize.isNotObject(obj) && dotize.isNotArray(obj)) {
      if (prefix) {
        return obj[prefix];
      }
      return obj;
    }

    for (let tProp in obj) {
      const tPropVal = obj[tProp];

      if (prefix) {
        const prefixRegex = new RegExp(`^${prefix}`);
        tProp = tProp.replace(prefixRegex, '');
      }

      tProp = tProp.replace(arStartRegex, '.$1');

      if (dotize.startsWith(tProp, '.')) tProp = tProp.replace(/^\./, '');

      var arrPath = tProp.split('.');
      var arrPathTypes = dotize.getPathType(arrPath);

      // has array on root
      if (
        !dotize.isUndefined(arrPathTypes) &&
        arrPathTypes[0] == dotize.valTypes.array &&
        Array.isArray(newObj) == false
      ) {
        newObj = [];
      }

      (function recurse(rPropVal, rObj, rPropValPrev, rObjPrev) {
        let currentPath = arrPath.shift();
        const currentPathType = arrPathTypes.shift();

        if (typeof currentPath == 'undefined' || currentPath == '') {
          newObj = rPropVal;
          return;
        }

        const isArray = currentPathType == dotize.valTypes.array;

        if (dotize.isNumber(currentPath)) currentPath = parseInt(currentPath);

        // has multiple levels
        if (arrPath.length > 0) {
          // is not assigned before
          if (typeof rObj[currentPath] == 'undefined') {
            if (isArray) {
              rObj[currentPath] = [];
            } else {
              rObj[currentPath] = {};
            }
          }

          recurse(rPropVal, rObj[currentPath], currentPath, rObj);
          return;
        }

        if (currentPathType == dotize.valTypes.array && rPropValPrev && rObjPrev) {
          if (Array.isArray(rObjPrev[rPropValPrev]) == false) rObjPrev[rPropValPrev] = [];
          rObjPrev[rPropValPrev].push(rPropVal);
        } else {
          rObj[currentPath] = rPropVal;
        }
      })(tPropVal, newObj);
    }

    return newObj;
  },
};
